"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const production_style_1 = __importDefault(require("../production.style"));
const production_action_1 = __importDefault(require("../production.action"));
const grid_1 = __importDefault(require("components/templates/grid"));
const svg_1 = require("components/atoms/svg");
const production_column_1 = require("../production.column");
const modal_1 = require("components/molecules/modal");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const PlanningProductionMutation = () => {
    const { dataGrid, dataGridHistory, dataStatesHistory, dataItemHistory, mutationMode, selectedYear, isLoadingUpload, isLoadingDownload, } = (0, store_1.useAppSelector)(state => state.adjustment.production);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const dispatch = (0, react_redux_1.useDispatch)();
    const showModal = mutationMode !== false;
    (0, react_1.useEffect)(() => {
        if (mutationMode === 'history')
            dispatch(production_action_1.default.getDataGridHistory(dataStatesHistory));
    }, [mutationMode]);
    const onFilterChangeHistory = (e) => {
        dispatch(production_action_1.default.onFilterChangeHistory(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { filter: e.filter });
        dispatch(production_action_1.default.getDataGridHistory(newDataStates));
    };
    const onSortChangeHistory = (e) => {
        dispatch(production_action_1.default.onSortChangeHistory(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { sort: e.sort });
        dispatch(production_action_1.default.getDataGridHistory(newDataStates));
    };
    const onDataStateChangeHistory = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { skip: types === 'page' ? (val - 1) * dataStatesHistory.take : 0, take: types === 'take' ? val : dataStatesHistory.take });
        dispatch(production_action_1.default.onDataStateChangeHistory(newDataStates));
    };
    const columnsRender = production_column_1.ProductionHistoryColumnProps.map(item => {
        if (item.field === 'action') {
            return Object.assign(Object.assign({}, item), { cell: (0, custom_cell_grid_1.actionCell)([
                    {
                        type: 'other',
                        permission: true,
                        icon: (0, jsx_runtime_1.jsx)(svg_1.DownloadDocIcon, { color: appTheme === 'dark' ? '#fff' : '#424242' }),
                        onClick: dataItem => window.open(dataItem.filepath, '_blank'),
                    }
                ]) });
        }
        else if (item.field === 'log_message') {
            return Object.assign(Object.assign({}, item), { cell: (0, custom_cell_grid_1.customLogsCell)({
                    type: 'other',
                    permission: true,
                    onClick: dataItem => {
                        dispatch(production_action_1.default.onClickMutation({ mutationMode: 'logs', dataItemHistory: dataItem }));
                    }
                }) });
        }
        else if (item.field === 'status') {
            return Object.assign(Object.assign({}, item), { cell: custom_cell_grid_1.customStatusCell });
        }
        return item;
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [mutationMode === 'upload' && ((0, jsx_runtime_1.jsx)(modal_1.ModalUploadDoc, { show: showModal, appTheme: appTheme, title: 'Upload Production Planning', isLoadingUpload: isLoadingUpload, isLoadingDownload: isLoadingDownload, style: production_style_1.default.modalUploadContainer(appTheme), onClose: () => dispatch(production_action_1.default.onClickMutation({ mutationMode: false, selectedYear })), onTemplate: () => {
                    const year = dataGrid.length > 0 ? selectedYear : '';
                    dispatch(production_action_1.default.onClickMutation({ mutationMode, isLoadingDownload: true }));
                    dispatch(production_action_1.default.onDownloadTemplateDocument({ year: year, mutationMode }));
                }, onUpload: (arg) => {
                    dispatch(production_action_1.default.onClickMutation({ mutationMode, isLoadingUpload: true }));
                    dispatch(production_action_1.default.onUploadDocumentTranshipment(Object.assign(Object.assign({}, arg), { year: selectedYear })));
                } })), mutationMode === 'logs' && ((0, jsx_runtime_1.jsx)(modal_1.ModalLog, { appTheme: appTheme, show: mutationMode === 'logs', onClose: () => dispatch(production_action_1.default.onClickMutation({ mutationMode: 'history' })), dataLog: dataItemHistory })), mutationMode === 'history' && ((0, jsx_runtime_1.jsx)(modal_1.Modal, Object.assign({ appTheme: appTheme, modalTitle: 'Upload History', show: mutationMode === 'history', style: production_style_1.default.modalHistoryContainer(appTheme), handleClose: () => dispatch(production_action_1.default.onClickMutation({ mutationMode: false, selectedYear })) }, { children: (0, jsx_runtime_1.jsx)(grid_1.default, { sortable: true, pageable: false, cardGrid: false, scrollable: 'scrollable', columns: columnsRender, style: production_style_1.default.gridHeight, dataGrid: dataGridHistory, sort: dataStatesHistory.sort, dataStates: dataStatesHistory, onSortChange: onSortChangeHistory, onFilterChange: onFilterChangeHistory, onPageChange: (v) => onDataStateChangeHistory('page', v), onTakeChange: (v) => onDataStateChangeHistory('take', v) }) })))] }));
};
exports.default = PlanningProductionMutation;
